import React, { useCallback, useMemo, useEffect, useState } from 'react'
import VertRule from '../../images/VerticalRule.svg'
import withConfig from '../../wrappers/withConfig'
import { saveAs } from 'file-saver'

const JobOverview = ({ data, config, isNonOG }) => {
    const disclosureKey = useMemo(() => data.pKey, [data])
    const { DISCLOSURE_URL } = config
    const { API_URL } = config

    const [supportedStates, setSupportedStates] = useState(null)

    // Fetch states from WellFinder
    useEffect(() => {
        fetch(`${API_URL}/FracFocus/wellfinderstates`)

            .then(res => res.text())
            .then(text => {
                console.log('Raw response:', text); 
                const data = JSON.parse(text);
                const stateList = data.ADATA.map(s => s.NAME.toLowerCase().trim());
                setSupportedStates(stateList);
            })
            .catch(err => {
                console.error('Error fetching WellFinder states:', err);
                setSupportedStates([]);
            });
    }, []);

    // Conditionally show the WellFinder button
    const showWellFinder = useMemo(() => {
        return (
            !isNonOG &&
            data.Latitude &&
            data.Longitude &&
            data.APINumber10 &&
            supportedStates &&
            supportedStates.includes(data.StateName?.toLowerCase().trim())
        )
    }, [ isNonOG, data.Latitude, data.Longitude, data.APINumber10, data.StateName, supportedStates])

    // PDF download handler
    const print = useCallback(
        () =>
            fetch(
                `${DISCLOSURE_URL}/${disclosureKey}/pdf`,
                {
                    headers: {
                        token: 'FbIg1hTgukBRfqwoMVBjjL5EvN1wzfD+3AsEMGps91kkMXZA+E8myU+3/zmZeyyypURTGA4i6vj8CUVN2tzf7w==',
                    },
                }
            )
                .then((res) => {
                    return res.blob()
                })
                .then(function (blob) {
                    saveAs(blob, 'Disclosure.pdf')
                }),
        [DISCLOSURE_URL, disclosureKey]
    )

    return (
        <>
            <div className="job_box">
                <img className="disclose_vr" src={VertRule} alt=''></img>
                <div className="job_details">
                    <p className="job">Job Completed: {data.JobEndDate}</p>
                    <p className="job">
                        Total Base Water Volume:{' '}
                        {data.TotalBaseWaterVolume != null
                            ? data.TotalBaseWaterVolume.toLocaleString('en-US')
                            : ''}
                    </p>
                    <p className="job">
                        Total Base Non-Water Volume:{' '}
                        {data.TotalBaseNonWaterVolume != null
                            ? data.TotalBaseNonWaterVolume.toLocaleString(
                                  'en-US'
                              )
                            : ''}
                    </p>
                    <p className="job">
                        True Vertical Depth:{' '}
                        {data.TVD != null
                            ? data.TVD.toLocaleString('en-US')
                            : ''}
                    </p>
                </div>
            </div>
            <div className="top">
                <h2 className="header_title">
                    Hydraulic Fracturing Fluid Composition
                </h2>

                <div className="button-stack">
                    {showWellFinder && (
                            <button
                                className="pdf"
                                onClick={() => {
                                    const latlon = encodeURIComponent(`${data.Latitude},${data.Longitude}`);
                                    const fullAPI = data.APINumber.replace(/-/g, "");
                                    const WELLFINDER_URL = config.WELLFINDER_URL || 'https://wellfinder.net';
                                    const url = `${WELLFINDER_URL}/map?well=${fullAPI}&loc=${latlon}`;
                                    window.open(url, '_blank');
                                }}
                            >
                                Show in WellFinder
                            </button>
                    )}

                    <button onClick={print} className="pdf">
                        PDF Disclosure Form
                    </button>
                </div>
            </div>




        </>
    )
}

export default withConfig(JobOverview)
